import React from 'react';

export const UserAccessContext = React.createContext(null);
